"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionAddLink = ShopPageSubscriptionAddLink;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const GenericModal_1 = require("../../shared/modals/GenericModal/GenericModal");
const i18n_1 = require("../../shared/utils/i18n");
const page_1 = require("../../shared/contexts/page");
const types_1 = require("../../shared/types");
const site_1 = require("../../shared/contexts/site");
const doterraTooltip_1 = __importDefault(require("../../shared/components/doterraTooltip"));
const provider_1 = require("../provider");
function ShopPageSubscriptionAddLink({ cartData, instantRewardsEnabled }) {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { showGlobalModal, hideGlobalModal } = (0, page_1.useModalsMutator)();
    const { context, contextPath } = (0, site_1.useSiteState)();
    const { hasSubscription } = (0, provider_1.useSubscriptionOverviewState)();
    let hasCartData = cartData && cartData.lrpSubType !== types_1.LrpSubType.INSTANT ? 'has-cartdata' : '';
    function handleAction() {
        window.location.href = `${contextPath}${context ? types_1.AppRoutes.MyCart : types_1.AppRoutes.CreateInstantOrder}`;
    }
    function subscriptionContextHandler() {
        if (cartData && cartData.lrpSubType !== types_1.LrpSubType.INSTANT) {
            let modalName = "Subscription-context";
            showGlobalModal(modalName, react_1.default.createElement(GenericModal_1.GenericModal, { title: (0, i18n_1.text)("text.multiMonth.loyalty.modal.context"), close: () => hideGlobalModal(modalName), cancelClassNames: 'hidden', acceptClassNames: 'btn btn-primary w-45', textActionButton: (0, i18n_1.text)("text.button.label.continue"), padding: '2rem', widthModal: '45rem', gap: 2, handleAction: handleAction, handleCancelAction: () => hideGlobalModal(modalName) }));
        }
    }
    if (!instantRewardsEnabled || (cartData === null || cartData === void 0 ? void 0 : cartData.lrpSubType) === types_1.LrpSubType.INSTANT || hasSubscription) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    return (react_1.default.createElement("div", { className: `createLRP text-center createInstantRewardsOrder-Migrated` },
        react_1.default.createElement("a", { id: "createInstantRewardsOrder", onClick: subscriptionContextHandler, className: `btn-createInstantRewardsOrder-Migrated ${hasCartData}`, "data-tooltip-html": t("text.tooltip.instant.rewards.order.disabled"), "data-tooltip-id": "tooltipDropdown" }, t("text.instantrewards.modal.action.button")),
        (cartData === null || cartData === void 0 ? void 0 : cartData.orderType) == types_1.OrderType.LRP && react_1.default.createElement(doterraTooltip_1.default, { id: "tooltipDropdown", place: "top" })));
}
